import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { ReactComponent as SwitchIcon } from 'assets/switch-unchecked.svg';
import { ReactComponent as SwitchCheckedIcon } from 'assets/switch-checked.svg';

import './Switcher.scss';

const Switcher = ({
    isChecked,
    changeStatusHandler,
    label,
    initialValue=false,
    labelPlacement,
    disabled
}) => (
        label
            ?
            <FormControlLabel className="custom-switch-control"
                control={
                    <Switch disableRipple icon={<SwitchIcon />} checkedIcon={<SwitchCheckedIcon />} className="custom-switch" disabled={disabled} checked={isChecked ? isChecked : initialValue} onChange={changeStatusHandler} />
                }
                label={label}
                labelPlacement={labelPlacement || "start"}
            />
            :
            <Switch disableRipple icon={<SwitchIcon />} checkedIcon={<SwitchCheckedIcon />} className="custom-switch" disabled={disabled} checked={isChecked} onChange={changeStatusHandler} />
    );

export default Switcher;
